import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { ContainerRefContext } from "./lib/Fields/lib/FieldContainer";
import { Preloader, Tab, Tabs } from "nlib/ui";
import { getSelectedBusinessData } from "selectors/businesses";
import { getTextsData } from "selectors/texts";
import { useDispatch, useSelector } from "react-redux";
import ActivityTab from "./lib/ActivityTab";
import Fields from "./lib/Fields";
import Files from "utils/Files";
import IntegrationServices from "const/IntegrationServices";
import MainApiActions from "actions/MainApiActions";
import React, { useCallback, useRef, useState } from "react";
import Texts from "utils/Texts";
import useDocumentContext from "hooks/useDocumentContext";
import useEnvVars from "hooks/useEnvVars";

const MODES = {
  DEFAULT: "default",
  ACTIVITY: "comments"
};

const MODES_LIST = Object.values(MODES);

export const FieldsPanel = ({ disabled }) => {
  const dispatch = useDispatch();

  const { uiTexts } = useSelector(getTextsData);

  const containerRef = useRef();

  const [{ editItem }] = useEnvVars();

  const [, tabToOpen] = editItem ? editItem.split(".") : [];

  const [currentTab, setCurrentTab] = useState(MODES_LIST.includes(tabToOpen) ? tabToOpen : MODES.DEFAULT);

  const { extraData: { integrationService } } = useSelector(getSelectedBusinessData);

  const {
    attachment,
    documentData: {
      extraData: { xeroSourceUrl, quickbooksSourceUrl, zohoSourceUrl } = {}
    }
  } = useDocumentContext();

  const [fetched, setFetched] = useState(false);

  const handleDownloadLinkClick = useCallback(async(event) => {
    event.preventDefault();
    setFetched(true);
    await dispatch(MainApiActions.fetchAttachmentUrl(attachment, true))
      .then((link) => link && Files.downloadContent(link));
    setFetched(false);
  }, [attachment, dispatch]);

  const handleExternalLinkClick = useCallback(() => {
    window.open(xeroSourceUrl || quickbooksSourceUrl || zohoSourceUrl, "_blank");
  }, [xeroSourceUrl, quickbooksSourceUrl, zohoSourceUrl]);

  return (
    <ContainerRefContext.Provider value={containerRef}>
      <div className={Css.fieldsPanel}>
        <div className={Css.header}>
          <div className={Css.links}>
            {!!attachment?.key && <div className={Css.downloadLink} title={attachment?.originalName || uiTexts.download}>
              <a disabled={fetched} onClick={handleDownloadLinkClick}>
                <Icons.DownloadSimple weight="bold" />
                <span>{attachment?.originalName || uiTexts.download}</span>
              </a>
            </div>}
            {!!(xeroSourceUrl || quickbooksSourceUrl || zohoSourceUrl) && (
              <div className={Css.externalLinkContainer} onClick={handleExternalLinkClick}>
                <a>
                  <Icons.ArrowSquareOut weight="bold" />
                  <span>
                    {Texts.replaceVars(
                      uiTexts.openInService,
                      { service: IntegrationServices.getByValue(integrationService).label }
                    )}
                  </span>
                </a>
              </div>
            )}
          </div>
          <Tabs className={Css.tabs} current={currentTab} onChange={setCurrentTab}>
            <Tab className={Css.tab} value={MODES.DEFAULT}>
              <Icons.NotePencil /><span>{uiTexts.document}</span>
            </Tab>
            <Tab className={Css.tab} value={MODES.ACTIVITY}>
              <Icons.Lightning /><span>{uiTexts.activity}</span>
            </Tab>
          </Tabs>
        </div>
        <div className={Css.fieldsContainer} ref={containerRef}>
          {({
            [MODES.DEFAULT]: <Fields />,
            [MODES.ACTIVITY]: <ActivityTab />
          }[currentTab])}
        </div>
        {disabled && <Preloader overlayOnly absolute />}
      </div>
    </ContainerRefContext.Provider>
  );
};
